<template>
  <v-app :class="mersBranded ? 'mers' : 'alerus'">
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Would you like to continue your session?</v-card-title>
        <v-card-text class="pt-0">You will be logged out after 60 seconds of inactivity.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="appButtonColor" @click="continueSession">Stay Logged In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar app :color="appHeaderColor">
      <v-toolbar-title v-if="retirementBranded">
        <v-btn
          to="/"
          active-class="retirement-active"
          large
          flat
          depressed
        >{{ retirementBrandedTitle }}</v-btn>
      </v-toolbar-title>
      <v-toolbar-title v-else-if="mersBranded">
        <router-link to="/">
          <v-img
            class="hidden-xs-only"
            :src="require('@/assets/imgs/MERS-Green-Black.png')"
            width="140px"
          />
          <v-img
            class="hidden-sm-and-up"
            :src="require('@/assets/imgs/MERS-Green-Black.png')"
            width="30px"
            height="26px"
          />
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <router-link to="/">
          <v-img
            class="hidden-xs-only"
            :src="require('@/assets/imgs/alerus-dark.svg')"
            width="150px"
            height="26px"
          />
          <v-img
            class="hidden-sm-and-up"
            :src="require('@/assets/imgs/alerus-mobile.svg')"
            width="30px"
            height="26px"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="$route.name === 'onlinebanking'"></v-toolbar-items>
      <v-toolbar-items
        v-else-if="user && ($route.name === 'account' || $route.name === 'documents')"
      >
        <v-btn to="/myaccount" flat :color="appButtonColor">My Profile</v-btn>
        <v-btn v-if="!mersBranded && !lastReview" to="/mydocuments" flat :color="appButtonColor">My Documents</v-btn>
        <v-btn v-if="!mersBranded && !lastReview" @click="pushSso" flat :color="appButtonColor">Return to My Alerus</v-btn>
        <v-btn v-else-if="mersBranded && !lastReview" @click="pushSso" flat :color="appButtonColor">Return to MERS FinFit</v-btn>
        <v-btn @click="logout" flat :color="appButtonColor">Sign Out</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-else-if="user && links.length">
        <v-btn to="/myaccount" v-if="!systemAdmin" flat :color="appButtonColor">My Profile</v-btn>
        <v-btn @click="logout" flat active-class="active-link" :color="appButtonColor">Sign Out</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-else-if="user">
        <v-btn
          to="/"
          @click="logout"
          flat
          active-class="active-link"
          :color="appButtonColor"
        >Sign Out</v-btn>
      </v-toolbar-items>

      <v-toolbar-items v-else>
        <v-btn
          to="/"
          @click="setState('signedOut')"
          flat
          :color="appButtonColor"
        >{{ mersBranded ? 'Log In' : 'Sign In' }}</v-btn>
        <v-btn
          to="/signup"
          @click="setState('signUp')"
          flat
          :color="appButtonColor"
        >{{ mersBranded ? 'Create Account' : 'Sign Up' }}</v-btn>
        <v-btn
          v-if="!mersBranded"
          to="/resetpassword"
          @click="setState('forgotPassword')"
          flat
          :color="appButtonColor"
        >Reset Password</v-btn>
        <v-btn
          v-else
          href="https://www.mersofmich.com/mers/resources/log-in/log-in-help/"
          target="_blank"
          flat
          :color="appButtonColor"
        >Need Help</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
    <v-footer height="auto" :color="appFooterColor">
      <v-container fluid>
        <v-layout row wrap align-center justify-center>
          <v-flex shrink class="footer-logo" v-if="mersBranded">
            <v-img :src="require('@/assets/imgs/MERS-White.png')" width="150px" />
            <div
              class="mt-1 white--text text-xs-center text-sm-left"
            >&copy;{{ new Date().getFullYear() }} Municipal Employees' Retirement System. All rights reserved.</div>
          </v-flex>
          <v-flex shrink class="footer-logo" v-else-if="!retirementBranded && !mersBranded">
            <v-img :src="require('@/assets/imgs/alerus.svg')" width="150px" height="26px" />
            <div
              class="mt-1 white--text text-xs-center text-sm-left"
            >&copy;{{ new Date().getFullYear() }} Alerus Financial. All rights reserved.</div>
          </v-flex>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-flex>
            <v-layout v-if="!mersBranded" row wrap justify-end class="footer-links">
              <v-flex align-center shrink>
                <v-btn target="_blank" to="/terms-conditions" flat tile class="white--text">
                  <v-icon>file_copy</v-icon>Terms and Conditions
                </v-btn>
              </v-flex>
              <v-flex align-center shrink>
                <v-btn class="hidden-xs-only white--text" href="tel:833-325-3787" flat tile>
                  <v-icon>phone</v-icon>
                  {{ csc.reg }}
                </v-btn>
                <v-btn class="hidden-sm-and-up white--text" href="tel:833-325-3787" flat tile>
                  <v-icon>phone</v-icon>
                  {{ csc.mobile }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-else column wrap align-end class="footer-links">
              <v-flex shrink>
                <v-btn class="white--text" href="tel:800-767-6377" flat tile>
                  <v-icon>phone</v-icon>
                  {{ mersCSC }}
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn target="_blank" to="/terms-conditions" flat tile class="white--text">
                  <v-icon>file_copy</v-icon>Terms and Conditions
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import "@/assets/fonts/fonts.css";
import { Promise } from "q";
export default {
  name: "App",
  data() {
    return {
      dialog: false,
      csc: {
        reg: "Client Service Center - (833-3ALERUS) - 833-325-3787",
        mobile: `Client Service Center - 833-325-3787`,
      },
      mersCSC: "Service Center: 800-767-6377",
      time: 0,
      logTime: 0,
    };
  },
  timers: {
    activityTime: {
      time: process.env.VUE_APP_ACTIVITY_TIME,
      repeat: true,
      autostart: false,
      callback: function () {
        this.openDialog();
      },
    },
    dialogTime: {
      time: process.env.VUE_APP_DIALOG_TIME,
      repeat: true,
      autostart: false,
      callback: function () {
        this.closeDialog();
      },
    },
  },
  watch: {
    user(val) {
      if (val) {
        // this.$timer.start("activityTime");
        // this.addListeners();
      }
    },
  },
  async created() {
    this.$root.$on("globalSignOut", async () => {
      await this.logout();
    });
  },
  mounted() {},
  computed: {
    ...mapState("user", [
      "confirmed",
      "user",
      "state",
      "sn",
      "retirementBranded",
      "mersBranded",
      "retirementBrandedTitle",
      "mersBrandedTitle",
      "links",
      "lastReview",
      "systemAdmin"
    ]),
    ...mapState("accounts", ["page"]),
    appHeaderColor() {
      return this.mersBranded ? "#F1F1F1" : "#E9E6E1";
    },
    appFooterColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
  },
  methods: {
    ...mapMutations("user", [
      "emptyUser",
      "unsetConfirmed",
      "setState",
      "setSN",
      "setSNAnswer",
      "setError",
      "setLoading",
      "setAnswer",
      "setPhones",
      "setStraightSso",
      "setLinks",
      "setAWSMfa",
      "setMfa",
      "setHub"
    ]),
    ...mapMutations("accounts", ["setPage"]),
    emptyTime() {
      console.log("empty time");
      this.$timer.stop("activityTime");
      this.$timer.start("activityTime");
    },
    emptyDialogTime() {
      this.$timer.stop("dialogTime");
      this.$timer.start("dialogTime");
    },
    addListeners() {
      window.addEventListener("click", this.emptyTime);
      window.addEventListener("mouseover", this.emptyTime);
    },
    removeListeners() {
      window.removeEventListener("click", this.emptyTime);
      window.removeEventListener("mouseover", this.emptyTime);
    },
    addDialogListeners() {
      window.addEventListener("click", this.emptyDialogTime);
      window.addEventListener("mouseover", this.emptyDialogTime);
    },
    removeDialogListeners() {
      window.removeEventListener("click", this.emptyDialogTime);
      window.removeEventListener("mouseover", this.emptyDialogTime);
    },
    async wait(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    closeDialog() {
      this.$timer.stop("dialogTime");
      this.dialog = false;
      this.removeDialogListeners();
      this.logout();
    },
    openDialog() {
      this.$timer.stop("activityTime");
      this.removeListeners();
      this.addDialogListeners();
      this.dialog = true;
      this.$timer.start("dialogTime");
    },
    continueSession() {
      this.removeDialogListeners();
      this.addListeners();
      this.$timer.stop("dialogTime");
      this.$timer.start("activityTime");
      this.dialog = false;
    },
    setLoginState(state) {
      this.setState(state);
      this.$router.push("/");
    },
    async logout() {
      await this.$Amplify.Auth.signOut();
      this.setState("signedOut");
      this.setSN(false);
      this.setSNAnswer(false);
      this.emptyUser();
      this.unsetConfirmed();
      this.setError(false);
      this.setMfa(false);
      this.setLoading(false);
      this.setAnswer({});
      this.setPhones([]);
      this.setLinks([]);
      this.$root.$emit("removeExtras");
      this.$router.push("/");
      this.setAWSMfa(false);
      // this.setHub(false)
    },
    pushSso() {
      this.unsetConfirmed();
      this.setStraightSso(true);
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
body {
  //font-family: "Poppins";
  .alerus {
    font-family: "the-serif";
  }
  .mers {
    font-family: "Ubuntu";
    // font-size: 120%;
    .v-btn__content {
      font-size: 1.2rem;
    }
  }
  margin: 0;
  height: 100%;
}
#app {
  //height: 100%;
}
.active {
  background-color: #d9d7d7;
}
.v-toolbar__items {
  .v-btn__content {
    text-transform: initial;
  }
}
.theme--light.v-footer {
  display: flex;
}
.v-btn__content {
  text-transform: capitalize;
  font-size: 1.1rem;
  i {
    margin-right: 0.25rem;
  }
}
:-ms-input-placeholder {
  color: #9c9c9c !important;
}
@media (max-width: 959px) {
  .footer-links {
    justify-content: center;
  }
  .footer-logo {
    .v-image {
      margin: 0 auto;
    }
  }
}
@media (max-width: 599px) {
  .v-image {
    margin: 0 auto;
  }
  .footer-links {
    justify-content: center;
    span {
      display: none;
    }
  }
  .footer-logo {
    margin-bottom: 0.5rem;
  }
}
@media (max-width: 375px) {
  .migration .v-btn {
    padding: 0;
    min-width: 70px;
  }
}
</style>

